import { lazy } from 'react';
import MainLayout from 'layouts/MainLayout';

const LandingPage = lazy(() => import('../pages/LandingPage'));
const ProjectPage = lazy(() => import('../pages/ProjectPage'));
const ArticleDetailPage = lazy(() => import('../pages/ArticleDetailPage'));

const routes = [{
    layout: MainLayout,
    routes: [{
        path: '/agents/blogger/:agentId',
        element: LandingPage,
        exact: true,
        analytics: { name: ["Agente", "Blogger"] },
    }, {
        path: '/agents/blogger/:agentId/projects/:projectId',
        element: ProjectPage,
        exact: true,
        analytics: { name: ["Agente", "Blogger", "Progetto"] },
    }, {
        path: '/agents/blogger/:agentId/projects/:projectId/articles/:articleId',
        element: ArticleDetailPage,
        exact: true,
        analytics: { name: ["Agente", "Blogger", "Articolo"] },
    }]
}];

export default routes;
